<template>
  <div>

      <h5>コメント一覧</h5>
      <hr>

      <div class="py-3 contents">
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th style="min-width: 150px;">写真</th>
              <th style="min-width: 150px;">商品のタイトル</th>
              <th style="min-width: 150px;">ニックネーム</th>
              <th style="min-width: 80px;">状態</th>
              <th style="min-width: 150px;">送受信日時</th>
              <th style="min-width: 80px;"></th>
            </tr>
            <tr v-for="(product_comment, index) in allGetProductComments">
              <td style="max-width: 150px;" @click="jumpProductDetailForComment(product_comment['products_id'])">
                <img class="" :src="product_comment['image1']" style="width: 100%;height: auto;">
              </td>
              <td @click="jumpProductDetailForComment(product_comment['products_id'])">
                {{ product_comment['title'] }}
              </td>
              <td>
                <span>{{ cinit(product_comment['nickname'], '-') }}</span>
              </td>
              <td>
                <span v-if="product_comment['status']==1">コメントをもらいました</span>
                <span v-else-if="product_comment['status']==2">コメントを送信しました</span>
              </td>
              <td>
                {{ convert_jst_for_message(product_comment['created_at']) }}
              </td>
              <td>
                <button class="btn btn-info" @click="jumpProductComment(product_comment['products_id'])">詳細</button>
              </td>
            </tr>
          </table>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  props: { 
    user: Object
  },
  data() {
    return {
      product_comments: [],
    }
  },
	methods: {
    jumpProductDetailForComment: function(id){
        this.$router.push({path: '/product/'+String(id)+'?anc=jump_comment'});
	  },
	  jumpProductComment: function(products_id){
        this.$router.push({path: '/product_comment/'+String(products_id)});
	  },
	  async get_product_comments() {
		  this.$store.dispatch('product/get_product_comments', {
        searchForm: null,
      }).then(res => {
		    console.log(res);
		    let ret = res.data;
		    this.product_comments = ret['product_comments'];
		    console.log(this.product_comments);
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
  },
	created() {
		this.get_product_comments();
	},
	computed: {
		allGetProductComments: function() {
			return this.product_comments;
		},
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/seller/comment.vue